import { useStrictInstance } from '@funtech-int/rival-react';

import { inMemoryCacheRef } from '../lib/inMemoryCache';

export function useInMemoryCache() {
    return useStrictInstance(inMemoryCacheRef);
}
